import { FC } from "react";
import { useFormContext } from "react-hook-form";

// Helpers
import { roundNumber } from "@/_helpers/number_functions";

// Interfaces
import { IUnit } from "@/interfaces/nutrition/nutrition_builder";
import { IRecipeBuilder } from "@/interfaces/recipe/recipe_builder";

// Components
import SelectInput from "@/components/select_input";
import { calculateCalories } from "@/_helpers/nutrition_helper";


interface _UnitInputProps {
    ingredientIndex: number;
    units: IUnit[];
    readonly: boolean;
}

const UnitInput: FC<_UnitInputProps> = ({ 
    ingredientIndex,
    units,
    readonly
}) => {

    const { control, setValue, getValues } = useFormContext<IRecipeBuilder>();

    const handleUnitChange = (unit: IUnit) => {
        setValue(`ingredients.${ingredientIndex}.unit`, unit);        
        const ingredients = getValues('ingredients')

        const protein = roundNumber(ingredients.reduce((acc, ingredient) => {
            return acc + (ingredient.macros.protein / 100) * (ingredient.amount * ingredient.unit.weight)
        }, 0), 1);
        const carbs = roundNumber(ingredients.reduce((acc, ingredient) => {
            return acc + (ingredient.macros.carbs / 100) * (ingredient.amount * ingredient.unit.weight)
        }, 0), 1);
        const fat = roundNumber(ingredients.reduce((acc, ingredient) => {
            return acc + (ingredient.macros.fat / 100) * (ingredient.amount * ingredient.unit.weight)
        }, 0), 1);
        const fibre = roundNumber(ingredients.reduce((acc, ingredient) => {
            return acc + (ingredient.macros.fibre / 100) * (ingredient.amount * ingredient.unit.weight)
        }, 0), 1);
        const alcohol = roundNumber(ingredients.reduce((acc, ingredient) => {
            return acc + (ingredient.macros.alcohol / 100) * (ingredient.amount * ingredient.unit.weight)
        }, 0), 1);

        setValue('calories', calculateCalories(protein, carbs, fat));
        setValue('protein', protein);
        setValue('carbs', carbs);
        setValue('fat', fat);
        setValue('fibre', fibre);
        setValue('alcohol', alcohol);
    };
    
    return (
        <SelectInput
            name={`ingredients.${ingredientIndex}.unit`}
            control={control}
            items={units}
            itemKey="uuid"
            itemLabel="label"
            returnObject
            hideErrorMessage
            alwaysHasValue
            gutter="0"
            minWidth={false}
            disabled={readonly}
            onChange={handleUnitChange}
        />
    )
}

export default UnitInput;